<template>
  <div id="miao" class="mb-0 mt-4">
    <Generic_Translations
      v-if="openLocationTranslations"
      :columns="locationColumns"
      :translations="locationTranslations"
      @closeTranslations="closeLocationTranslations"
      @saveTranslations="saveLocationTranslations"
    ></Generic_Translations>
    <Location_Batchgroups
      v-if="openLocationBatchgroups"
      :locationBatchgroupConditions="locationBatchgroupsConditions"
      :locationBatchgroups="locationBatchgroups"
      @deleteLocationBatchgroup="deleteBatchgroup"
      @closeLocationBatchgroups="closeLocationBatchgroups"
      @saveLocationBatchgroups="saveLocationBatchgroups"
    ></Location_Batchgroups>
    <v-toolbar flat color="third" class="pl-0 toolbarLocations">
      <!--  <v-checkbox v-model="selectAll" hide-details class="shrink mr-2" label="Select all"></v-checkbox>-->
      <v-tooltip bottom>
        <v-btn icon slot="activator" @click="addNewLocation">
          <v-icon>add</v-icon>
        </v-btn>
        <span>{{ $translate("ADD_LOCATION") }}</span>
      </v-tooltip>
      <v-divider class="mx-3" inset vertical></v-divider>

      <!--      <v-tooltip bottom>-->
      <!--        <v-btn icon slot="activator" @click="addNewLocation">-->
      <!--          <v-icon>add</v-icon>-->
      <!--        </v-btn>-->
      <!--        <span>{{$translate('ADD_LOCATION')}}</span>-->
      <!--      </v-tooltip>-->
      <v-spacer></v-spacer>
      <v-divider class="mx-3" inset vertical></v-divider>
      {{ sort ? $translate("SORT") + ": A-Z" : $translate("SORT") + ": Z-A" }}
      <v-btn icon @click="sortLocations">
        <v-icon>{{ sort ? "arrow_drop_up" : "arrow_drop_down" }}</v-icon>
      </v-btn>
    </v-toolbar>

    <div class="text-xs-center">
      <v-list v-if="paginatedLocations.length > 0" class="scrollList2 pl-2">
        <template v-for="(item, index) in paginatedLocations">
          <div :key="index">
            <v-divider :inset="item.inset"></v-divider>
            <v-list-tile class="showOver">
              <v-list-tile-action>
                <v-checkbox v-model="item.status"></v-checkbox>
              </v-list-tile-action>
              <v-flex xs6>
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{
                    getItemDescription(item)
                  }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-flex>
              <v-spacer></v-spacer>
              <div class="align-right">
                <v-tooltip v-if="item.editable" bottom>
                  <v-btn
                    fab
                    icon
                    small
                    round
                    slot="activator"
                    class="primary"
                    @click="editLocation(item)"
                  >
                    <v-icon dark>edit</v-icon>
                  </v-btn>
                  <span>{{ $translate("EDIT_LOCATION") }}</span>
                </v-tooltip>
                <v-tooltip v-if="item.editable" bottom>
                  <v-btn
                    fab
                    icon
                    small
                    round
                    slot="activator"
                    class="primary"
                    @click="getBatchgroups(item)"
                  >
                    <v-icon dark>assessment</v-icon>
                  </v-btn>
                  <span>{{ $translate("EDIT_BATCHGROUPS") }}</span>
                </v-tooltip>
                <v-tooltip v-if="item.editable" bottom>
                  <v-btn
                    fab
                    icon
                    small
                    round
                    slot="activator"
                    class="primary"
                    @click="getLocationTranslations(item)"
                  >
                    <v-icon dark>language</v-icon>
                  </v-btn>
                  <span>{{ $translate("EDIT_TRANSLATIONS") }}</span>
                </v-tooltip>
                <v-tooltip v-if="item.deletable" bottom>
                  <v-btn
                    fab
                    icon
                    small
                    round
                    slot="activator"
                    class="secondary"
                    @click="showDeleteLocationDialog(item)"
                  >
                    <v-icon dark>delete</v-icon>
                  </v-btn>
                  <span>{{ $translate("DEL_LOCATION") }}</span>
                </v-tooltip>
              </div>
            </v-list-tile>
          </div>
        </template>
      </v-list>
      <v-list v-else class="scrollList2 pl-2">
        <v-layout align-space-around justify-space-around row fill-height>
          <v-icon
            justify-space-around
            disabled
            color="primary"
            style="font-size: 100px"
            >ballot</v-icon
          >
        </v-layout>
      </v-list>
    </div>
    <v-pagination
      class="pagination mt-0"
      total-visible="7"
      v-model="page"
      :length="nPages"
      @input="selectPage"
      @next="nextPage"
      @previous="previousPage"
    ></v-pagination>
    <v-dialog v-model="deleteDialog" persistent max-width="290" hide-overlay>
      <v-card class="round_dialog_roles">
        <v-progress-linear
          v-if="showProgress"
          :indeterminate="true"
          color="blue"
        ></v-progress-linear>
        <v-card-title class="headline">{{
          $translate("DEL_LOCATION")
        }}</v-card-title>
        <v-card-text
          >{{ this.locationToBeDeleted.name }} -
          {{ this.locationToBeDeleted.locationId }}</v-card-text
        >
        <v-card-text v-if="showDeleteStrictConfirmation"
          >{{ $translate("LOCATIONS_CONTAINS") }} {{ deleteChildren.length }}
          {{ $translate("LOCATION_ARE_YOU_SURE") }}</v-card-text
        >

        <v-list class="pl-2">
          <v-list-tile v-for="(c, index) in deleteChildren" :key="index"
            >{{ c.Name }} - {{ c.Depth }}</v-list-tile
          >
        </v-list>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            class="text-capitalize"
            round
            @click.native="cancelDeleteDialog()"
            >{{ $translate("CANCEL") }}</v-btn
          >
          <v-btn
            color="primary"
            class="text-capitalize"
            round
            :disabled="this.disableDeleteButton"
            @click.native="deleteLocation(deleteChildren.length != 0)"
            >{{ $translate("DELETE") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as dssRequest from "../api/dssRequest";
import BaseObject from "../objects/BaseObject";
import LocationObject from "../objects/LocationObject";
import _ from "lodash";
import BaseComponent from "./base/BaseComponent";
import appConfig from "../../config/app_config";
import Generic_Translations from "./Generic_Translations";
import Location_Batchgroups from "./Locations_Batchgroups";

export default {
  name: "Locations_Main",
  extends: BaseComponent,
  props: {
    properties: Object,
  },
  data() {
    return {
      selectedLocation: {},
      locationBatchgroups: [],
      locationBatchgroupsConditions: [],
      openLocationBatchgroups: false,
      locationTranslations: {},
      locationColumns: [],
      openLocationTranslations: false,

      deleteChildren: [],
      showDeleteStrictConfirmation: false,
      // selectedFilters: [],
      sort: true,
      selectAll: false,
      page: 1,
      nPages: 1,
      elementXpage: 12,
      deleteDialog: false,
      showProgress: false,
      locationToBeDeleted: {},
      disableDeleteButton: false,
      paginatedLocations: [],
      mapIcons: [],
    };
  },
  components: {
    // Importing the components that are used within this component
    Generic_Translations,
    Location_Batchgroups,
  },
  computed: {
    ...mapGetters({
      // filters: "getFilterTags",
      locations: "locationsModule/getLocations",
      _selectedPartOfLocation: "getSelectedPartOfLocation",
    }),
  },
  watch: {
    selectAll: function (next, to) {
      this.locations.forEach((e) => {
        e.status = next;
      });
    },
    locations: function (next, to) {
      this.selectAll = false;
      this.page = 1;
      this.recountPage();
    },
  },
  created() {
    this.getMapIcons();
    window.EventBus.listen(
      "getLocationTranslations",
      this.getLocationTranslations
    );
  },
  // mounted() {
  //       let page = "Locations_Main";
  //       this.$store.commit("setCurrentComponent", page);
  // },
  beforeDestroy() {
    let page = "Locations_Main";
    this.$store.commit("setCurrentComponent", page);
    window.EventBus.removeListener(
      "getLocationTranslations",
      this.getLocationTranslations
    );
  },
  methods: {
    getBatchgroups(location) {
      const payload = {};
      dssRequest.doRequest(
        (response) => {
          console.log("The call getBatchgroups was successful", response);
          this.locationBatchgroups = [];
          this.locationBatchgroupsConditions = [];
          this.selectedLocation = {};
          this.locationBatchgroups = Object.values(response.data.BatchGroups);
          if (Object.keys(response.data.Conditions > 0)) {
            this.locationBatchgroupsConditions = Object.values(
              response.data.Conditions
            );
          }
          this.selectedLocation = location;
          this.openLocationBatchgroups = true;
        },
        (error) => {
          console.log("The call getBatchgroups was not successful", error);
        },
        "getBatchGroups",
        location.locationId,
        payload
      );
    },
    getLocationTranslations(location) {
      console.log("Brian DO WE GET HIEERRRRS", location);

      const payload = {};
      dssRequest.doRequest(
        (response) => {
          console.log("The call getTranslations was successful", response);
          this.locationTranslations = {};
          this.locationColumns = [];
          this.selectedLocation = {};
          this.locationTranslations = response.data.Translations;
          this.locationColumns = response.data.ColumnNames;
          this.openLocationTranslations = true;
          this.selectedLocation = location;
        },
        (error) => {
          console.log("The call getTranslations was not successful", error);
        },
        "getTranslations",
        location.locationId,
        payload
      );
    },
    editLocation(location) {
      const payload = {
        LocationId: location.locationId,
        StructuredReply: true,
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The generic call 'getLocationData' on the main location on - Dashboard.vue - was successful",
            response
          );
          const fullLocationObject = BaseObject._toLowerCaseObjectPropertiesAtFirstLevelWithOutLodash(
            response.data
          );

          let k = Object.keys(fullLocationObject.containers)[0];
          const newK = k[0].toUpperCase() + k.substring(1, k.length);
          const partOf = {
            locationId: newK,
            name: fullLocationObject.containers[k],
            depth: fullLocationObject.depth - 1, //tricks to re-apply the same depth
          };

          fullLocationObject.tags = {};
          fullLocationObject.tags = Object.assign(
            {},
            fullLocationObject.locationTags
          );
          // delete fullLocationObject.locationTags;
          //copy the memberOf tags

          //
          // fullLocationObject.memberOf = location.memberOf;
          console.log("fullLocationObject", fullLocationObject);
          window.EventBus.fire("setMainContentComponent", {
            component: "OperationalScreen_MapQuadrant",
            params: {
              type: "edit",
              location: fullLocationObject,
              partOf: this._selectedPartOfLocation,
            },
          });
          window.EventBus.fire("setSideComponentName", {
            component: "AddLocation",
            params: {
              type: "edit",
              location: fullLocationObject,
              partOf: partOf,
              mapIcons: this.mapIcons,
            },
          });
        },
        (error) => {
          console.error(
            "The generic call 'getLocationData' on the main location on - Dashboard.vue - was not successful",
            error
          );
          // window.EventBus.fire('triggerGenericErrorDialog', 'W_GLD_001');
        },
        "getLocationData",
        this.$store.getters.getAccountInfo.LocationId,
        payload,
        600000,
        false
      );
    },
    deleteLocation(confirmation = false) {
      this.showProgress = true;
      this.disableDeleteButton = true;
      let payload = {
        PartnerId: this.$store.getters["auth/partnerId"],
        LocationId: this.locationToBeDeleted.locationId,
      };
      if (!confirmation) {
        dssRequest.doRequest(
          (response) => {
            console.log("The call for deleteLocation was successful", response);
            if (response.data.Children) {
              let o = BaseObject._createArrayWithObjects(
                response.data.Children
              );
              this.disableDeleteButton = false;
              this.deleteChildren = BaseObject._createArrayWithObjects(
                response.data.Children
              );
              this.showDeleteStrictConfirmation = true;
            } else {
              this.deleteChildren = [];
              this.showDeleteStrictConfirmation = false;
              window.EventBus.fire("getLocations", {});
              setTimeout(() => {
                this.disableDeleteButton = false;
                this.deleteDialog = false;
                this.showProgress = false;
              }, 2000);
            }
          },
          (error) => {
            console.log(
              "The call for deleteLocation was not successful",
              error
            );
            this.deleteChildren = [];
            this.disableDeleteButton = false;
            setTimeout(() => {
              this.deleteDialog = false;
              this.showProgress = false;
            }, 2000);
            // window.EventBus.fire("triggerGenericErrorDialog", error.errorMsg);
          },
          "deleteLocation",
          appConfig.dss.locationMgr,
          payload
        );
      } else {
        dssRequest.doRequest(
          (response) => {
            console.log(
              "The call for 'deleteLocationConfirmed' on - Dashboard.vue - was successful",
              response
            );
            this.deleteChildren = [];
            window.EventBus.fire("getLocations", {});
            setTimeout(() => {
              this.deleteDialog = false;
              this.showProgress = false;
              this.showDeleteStrictConfirmation = false;
              this.disableDeleteButton = false;
            }, 2000);
          },
          (error) => {
            this.deleteChildren = [];
            console.log(
              "The call for 'deleteLocationConfirmed' on - Dashboard.vue - was not successful",
              error
            );
            setTimeout(() => {
              this.deleteDialog = false;
              this.showProgress = false;
              this.showDeleteStrictConfirmation = false;
              this.disableDeleteButton = false;
            }, 2000);
            // window.EventBus.fire("triggerGenericErrorDialog", e.errorMsg);
          },
          "deleteLocationConfirmed",
          appConfig.dss.locationMgr,
          payload
        );
      }
    },
    getItemDescription(item) {
      let s =
        item.description.length > 0 ? item.description : "<No Description>";

      // if (!_.isEmpty(item.memberOf)) {
      //   let owner = "Owner: ",
      //     ownerDesc = "";
      //   let shared = "Shared: ",
      //     sharedDesc = "";
      //   for (let [k, v] of Object.entries(item.memberOf)) {
      //     if (v.grantType === "OWNER") ownerDesc += v.userGroupName + " ";
      //
      //     if (v.grantType === "VISIBLE") sharedDesc += v.userGroupName + " ";
      //   }
      //   if (ownerDesc.length > 0) s += " " + owner + ownerDesc;
      //
      //   if (sharedDesc.length > 0) s += " " + shared + " - " + sharedDesc;
      // }
      return s;
    },
    recountPage() {
      this.nPages = Math.ceil(this.locations.length / this.elementXpage);
      let start = (this.page - 1) * this.elementXpage;
      this.paginatedLocations = [];
      this.paginatedLocations = this.locations.filter(
        (e, i) => i >= start && i < start + this.elementXpage
      );

      this.paginatedLocations.forEach((l) => {
        if (this.$store.getters["auth/userLevel"] === 6) {
          if (l.partnerId !== "-1") {
            l.editable = true;
            l.deletable = true;
          } else {
            l.editable = false;
            l.deletable = false;
          }
        } else {
          if (l.accountId === this.$store.getters.getCurrentAccountId) {
            l.editable = true;
            l.deletable = true;
          } else {
            l.editable = false;
            l.deletable = false;
          }
        }
      });
    },
    /**
     * function to parse the replied property Matrix
     * in one array of objects, all the columns will
     * be object properties,
     * the celldata property is an object instead of an array
     */
    parseObject(reply) {
      let outputArray = [];
      const cellData = reply.celldata;

      for (let [k, v] of Object.entries(cellData)) {
        const translateObj = this.parseStructToObject(v, reply.columns);
        outputArray.push(translateObj);
      }
      return outputArray;
    },
    /**
     * internal function to create object property
     * from columns
     */
    parseStructToObject(data, columns) {
      let object = {};

      for (let p in columns) {
        if (columns.hasOwnProperty(p)) {
          let index = columns[p];
          switch (p) {
            default:
              object[p] = data[index];
          }
        }
      }
      return object;
    },
    selectPage(number) {
      this.recountPage();
    },
    nextPage() {
      this.recountPage();
    },
    previousPage() {
      this.recountPage();
    },
    cancelDeleteDialog() {
      this.showProgress = false;
      this.deleteDialog = false;
      this.deleteChildren = [];
      this.showDeleteStrictConfirmation = false;
    },
    sortLocations() {
      console.log("this.locations22", this.locations);
      this.locations.sort((a, b) =>
        a.name.localeCompare("x", "en-US", {
          sensitivity: "base",
        })
      );
      console.log("this.locations22", this.locations);
      this.sort = !this.sort;
      this.$store.commit("setSortLocationOrder", this.sort);
    },
    showDeleteLocationDialog(location) {
      this.deleteDialog = true;
      this.locationToBeDeleted = location;
    },
    closeLocationBatchgroups() {
      this.selectedLocation = {};
      this.openLocationBatchgroups = false;
    },
    closeLocationTranslations() {
      this.selectedLocation = {};
      this.openLocationTranslations = false;
    },
    saveLocationBatchgroups(batchgroupData) {
      console.log("Brian batchgroupData", batchgroupData);
      let payload = {
        BatchGroupId: batchgroupData.BatchGroupId,
        Name: batchgroupData.Name,
        Type: batchgroupData.Type,
        StartTime: batchgroupData.StartTime,
        EndTime: batchgroupData.EndTime,
        State: batchgroupData.State,
        Conditions: batchgroupData.Conditions,
      };
      if (batchgroupData.Type === "Repeating") {
        payload.StartDate = batchgroupData.StartDate;
        payload.EndDate = batchgroupData.EndDate;
        payload.Days = batchgroupData.Days;
      } else {
        payload.Dates = batchgroupData.Dates;
      }
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call for saveBatchgroups on - Locations_Main.vue - was successful",
            response
          );
          window.EventBus.fire(
            "activateSnackBar",
            "Batchgroup successfully saved"
          );
          this.getBatchgroups(this.selectedLocation);
        },
        (error) => {
          console.log(
            "The call for saveBatchgroup on - Locations_Main.vue - was not successful",
            error
          );
          // window.EventBus.fire("triggerGenericErrorDialog", error.errorMsg);
        },
        "saveBatchGroup",
        this.selectedLocation.locationId,
        payload
      );
    },
    deleteBatchgroup(item) {
      console.log("Brian going to delete", item);
      let payload = {
        BatchGroupId: item.BatchGroupId,
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call for deleteBatchgroup on - Locations_Batchgroups.vue - was successful",
            response
          );
          window.EventBus.fire(
            "activateSnackBar",
            "Batchgroup successfully deleted"
          );
          this.getBatchgroups(this.selectedLocation);
        },
        (error) => {
          console.log(
            "The call for deleteBatchgroup on - Locations_Batchgroups.vue - was not successful",
            error
          );
          // window.EventBus.fire("triggerGenericErrorDialog", error.errorMsg);
        },
        "deleteBatchGroup",
        this.selectedLocation.locationId,
        payload
      );
    },
    saveLocationTranslations(translationData) {
      let payload = {};
      payload.Translations = translationData;
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call for saveTranslations on - Locations_Main.vue - was successful",
            response
          );
          this.openLocationTranslations = false;
          this.selectedLocation = {};
        },
        (error) => {
          console.log(
            "The call for saveTranslations on - Locations_Main.vue - was not successful",
            error
          );
          // window.EventBus.fire("triggerGenericErrorDialog", error.errorMsg);
        },
        "saveTranslations",
        this.selectedLocation.locationId,
        payload
      );
    },
    addNewLocation() {
      window.EventBus.fire("setMainContentComponent", {
        component: "OperationalScreen_MapQuadrant",
        params: { partOf: this._selectedPartOfLocation },
      });
      window.EventBus.fire("setSideComponentName", {
        component: "AddLocation",
        params: {
          partOf: this._selectedPartOfLocation,
          mapIcons: this.mapIcons,
        },
      });
    },
    removeFilter(e) {},
    getMapIcons() {
      let payload = {};

      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call [getMapIcons] on Account [%s] in component [Locations_Main] succeeded",
            this.currentAccountId,
            response
          );
          this.mapIcons = [];
          if (
            response.data.hasOwnProperty("MapIcons") &&
            response.data.MapIcons !== undefined
          ) {
            this.mapIcons = [...response.data.MapIcons];
          }
        },
        (error) => {
          console.log(
            "The call [getMapIcons] on Account [%s] in component [Locations_Main] failed",
            this.currentAccountId,
            error
          );
        },
        "getMapIcons",
        this.currentAccountId,
        payload
      );
    },
  },
};
</script>
<style lang="scss" scoped="">
.pagination {
  position: relative;
  bottom: 0;
}

.toolbarLocations {
  max-width: 98%;
}

.scrollList2 {
  height: 70vh;
  max-width: 98%;
  overflow-x: hidden;
  overflow-y: auto;
}
.showOver:hover {
  background-color: lightgray;
}
</style>
